import { Component, OnInit, Input } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators, FormGroupDirective } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { PrimaryContactInformation, MerchantProfileSelectItem, PersonValidator, PersonService, MerchantAccount, MerchantAccountType } from '../../../shared';

@Component({
    selector: 'app-primary-contact-information',
    templateUrl: './primary-contact-information.component.html'
})
export class PrimaryContactInformationComponent implements OnInit {

    @Input() formGroupName: string;
    @Input() showErrors: boolean;

    primaryContactInformation: PrimaryContactInformation;
    primaryContactInformationFormGroup: FormGroup;
    get primaryContactPerson(): AbstractControl {
        return this.primaryContactInformationFormGroup.get('primaryContactPerson');
    }
    get primaryContactFax(): AbstractControl {
        return this.primaryContactInformationFormGroup.get('primaryContactFax');
    }

    merchantProfiles: MerchantProfileSelectItem[];
    isCashnet: boolean;

    constructor(
        private readonly rootFormGroup: FormGroupDirective,
        private readonly fb: FormBuilder,
        private readonly route: ActivatedRoute,
        private readonly personService: PersonService
    ) {
    }

    ngOnInit() {
        this.route.data.subscribe(({ merchantAccount }: { merchantAccount: MerchantAccount }) => {
            this.isCashnet = merchantAccount.merchantAccountType === MerchantAccountType.Cashnet;
            this.primaryContactInformation = merchantAccount.primaryContactInformation;
            this.primaryContactInformationFormGroup = this.rootFormGroup.control.get(this.formGroupName) as FormGroup;
            this.primaryContactInformationFormGroup.addControl("primaryContactPerson", this.fb.control(this.primaryContactInformation.primaryContact, [Validators.required], [PersonValidator.hasPersonCompletedCashHandlingTraining(this.personService)]));
            var primaryContactFaxValidators = this.isCashnet ? [] : [Validators.required, Validators.pattern("\\(\\d{3}\\)\\s\\d{3}-\\d{4}")];
            this.primaryContactInformationFormGroup.addControl("primaryContactFax", this.fb.control(this.primaryContactInformation.primaryContactFax, primaryContactFaxValidators));
        });
    }

    onDeletePrimaryContact() {
        this.primaryContactPerson.setValue(null);
        this.primaryContactPerson.updateValueAndValidity();
    }
}